import { UseFormPayload } from '@domain-group/react-hooks'
import { Form, SectionDivider } from '@domain-group/suit-theme'

interface PropertyDetailsProps {
  campaignComparableFormPayload: UseFormPayload,
}

const ComparableDetails = (props: PropertyDetailsProps) => {
  const { campaignComparableFormPayload } = props

  const {
    entityState: {
      comparable_source,
    },
    handlers,
  } = campaignComparableFormPayload

  return (
    <>
      <SectionDivider boxProps={{ marginTop: 'large' }}>Comparable Details</SectionDivider>

      <Form.Field label="Comparable Source" marginTop="large">
        {/*
         // @ts-expect-error TS2322 */}
        <select name="comparable_source" value={comparable_source} {...handlers}>
          <option value="agency">Agency</option>
          <option value="market">Market</option>
        </select>
      </Form.Field>
    </>
  )
}

export default ComparableDetails
